/** @file Mantine component default props and style overrides. */
import { radius } from './radius';
import { shadows } from './shadows';

export const components = {
  Button: {
    defaultProps: {
      variant: 'outline',
      radius: radius.control
    },
    styles: {
      root: {
        boxShadow: 'none'
      }
    }
  },
  Card: {
    defaultProps: {
      radius: radius.surface,
      shadow: shadows.card,
      padding: 'lg'
    }
  },
  Modal: {
    defaultProps: {
      radius: radius.surface,
      shadow: shadows.modal
    }
  },
  Paper: {
    defaultProps: {
      radius: radius.surface,
      shadow: shadows.flat
    }
  },
  Drawer: {
    defaultProps: {
      padding: 'md'
    }
  },
  Tooltip: {
    defaultProps: {
      // Show on tap for touch devices, not only on hover.
      events: { hover: true, focus: true, touch: true }
    }
  },
  ActionIcon: {
    defaultProps: {
      variant: 'subtle'
    }
  },
  TextInput: {
    defaultProps: {
      radius: radius.control
    }
  },
  Notification: {
    defaultProps: {
      radius: radius.control
    }
  }
};
